import { globalVariables } from "helper/globalVariables";
import { useContext, useEffect, useRef, useState } from "react";
import { TabBar } from "shared/Components/tabBar";
import { SwitchRole } from "./Components/SwitchRole";
import { useDispatch, useSelector } from "react-redux";
import { PopUpMessages } from "shared/Components/popUpMessages";
import {
  DOG_PROFILE,
  HOST_PROFILE,
  MEMBER_PROFILE,
  SWITCH_ROLE,
  APPLY_FOR_JUDGE,
  adminTabs,
  dashboardTabs,
  hostTabs,
  dashboardTabsApproved,
} from "./Components/constants";
import { BottomButtons } from "shared/Components/bottomButtons";
import PageInfo from "shared/Components/pageInfo";
import { useMediaQuery } from "react-responsive";
import { MemberProfile } from "./Components/MemberProfile";
import { ApplyForJudge } from "./Components/ApplyForJudge";
import DogsProfile from "./Components/DogsProfile";
import moment from "moment";
import { useLazyQuery, useQuery } from "@apollo/client";
import {
  getDogsQuery,
  updateRegisteredDogs,
} from "redux/features/dogSlice/dogGql";

import { client } from "helper/apolloConfig";
import { LoaderDispatchContext } from "./Context/EditAndLoaderContext";
import { SubmitButton } from "./Components/SubmitButtons";
import { Button } from "shared/Components/button";
import { edit } from "helper/icons";
import { RoleContext, RoleDispatchContext } from "context/RoleContext";
import { ROLE, roles } from "helper/utility";
import { HostProfile } from "./Components/HostProfile";
import { setHostProfile } from "redux/features/hostSlice/profile/hostProfileSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { setMemberDetails } from "redux/features/memberSlice/memberSlice";
import { setHostDetails } from "redux/features/hostSlice/addTrialSlice/addTrialSlice";
import { getMemberProfileQuery } from "redux/features/memberSlice/memberGql";
import ScrollToTop from "shared/Components/scrollToTop";

export const MyProfile = () => {
  const role = useContext(RoleContext);
  const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  const setLoaderState = useContext(LoaderDispatchContext);
  const navigate = useNavigate();
  const [isEditable, setEditable] = useState(false);
  const {
    data,
    loading: DogsLoading,
    refetch,
  } = useQuery(getDogsQuery, {
    fetchPolicy: "no-cache",
  });
  const dispatchSetRole = useContext(RoleDispatchContext);
  const dispatch = useDispatch();
  const memberDetails = useSelector(
    (state) => state?.auth?.memberReducer?.memberDetails
  );

  const dogsFormRef = useRef();
  const modalRef = useRef();
  const memberProfileRef = useRef();
  const hostProfileRef = useRef();
  const params = new URLSearchParams(window.location.search);
  const option = params.get("option");
  const { pathname } = useLocation();

  const [profileDataSave, setProfileDataSave] = useState({
    title: "",
    desc: "",
    type: "pending",
  });
  const userRole = useSelector(
    (state) => state?.auth?.memberReducer?.memberDetails?.role
  );

  const FetchTabs = () => {
    if (role === ROLE.Host) {
      return hostTabs;
    } else if (role === ROLE.Member) {
      if (memberDetails?.judgeStatus == "approved") {
        return dashboardTabsApproved;
      } else {
        return dashboardTabs;
      }
    } else if (role === ROLE.SuperAdmin) {
      return adminTabs;
    }
  };

  const [selectedRole, setSelectedRole] = useState("");
  const [selectedTab, setSelectedTab] = useState(FetchTabs()[0]);

  const [getProfileData, { data: profileData, loading }] = useLazyQuery(
    getMemberProfileQuery,
    {
      fetchPolicy: "no-cache",
    }
  );

  useEffect(() => {
    getProfileData();
  }, []);

  useEffect(() => {
    if (profileData?.getMyMemberProfile) {
      console.log("Profile Data " , profileData?.getMyMemberProfile);
      dispatch(setMemberDetails(profileData?.getMyMemberProfile));
      // dispatch(setHostDetails(profileData?.getMyMemberProfile));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileData?.getMyMemberProfile]);

  //   Default set role to dropdown
  useEffect(() => {
    if (role !== "") {
      setSelectedRole(role);
    }
    if (option === "switchRole") {
      setSelectedTab(SWITCH_ROLE);
    }
  }, [role]);

  //   Manage tab changes
  const onTabChange = (index) => {
    setSelectedTab(FetchTabs()[index]);
    if (isEditable) {
      setEditable(false);
    }
    if (
      FetchTabs()[index] === "Switch Roles" ||
      pathname.includes("dashboard/switchRole")
    ) {
      getProfileData();
      navigate(`${pathname}?option=switchRole`);
    } else {
      navigate(`${pathname}`);
    }
    if (
      FetchTabs()[index] === "Switch Roles" ||
      pathname.includes("dashboard/switchRole")
    ) {
      navigate(`${pathname}?option=switchRole`);
    } else {
      navigate(`${pathname}`);
    }
  };

  // Manage select role

  //   Update role in store
  const handelSaveChanges = async () => {
    //Save Member Profile
    if (selectedTab === MEMBER_PROFILE) {
      memberProfileRef.current?.saveChanges();
      //Save Switch Role
    } else if (selectedTab === SWITCH_ROLE) {
      // modalRef.current.openModal();
      // setProfileDataSave({
      //   ...profileDataSave,
      //   title: globalVariables.profileRoleSuccess,
      //   desc: globalVariables.proleRoleSuccessDescription,
      //   type: "success",
      // });
      // Save Dog Profile
    } else if (selectedTab === DOG_PROFILE) {
      const dogs = await dogsFormRef.current.saveChanges();
      setLoaderState(true);
      if (dogs && dogs.length > 0) {
        const dogsPayload = dogs.map((dog) => {
          return {
            id: dog.id,
            call_name: dog?.callName,
            registration_name: dog?.registrationName,
            breed: dog?.breed,
            breed_mix: dog?.breedMix,
            gender: dog?.gender,
            date_of_birth: moment(dog?.dob).format(),
            rescue: dog?.isRescueYes,
            dogImage: dog?.image,
          };
        });
        client
          .mutate({
            mutation: updateRegisteredDogs,
            variables: { data: dogsPayload },
          })
          .then(() => {
            refetch().then(() => {
              setEditable(false);
              setLoaderState(false);
            });
          })
          .catch((error) => {
            console.error("Error updating dogs:", error);
            setLoaderState(false);
          });
      } else {
        setLoaderState(false);
      }
    } else if (selectedTab === HOST_PROFILE) {
      hostProfileRef.current?.saveChanges();
    }
  };
  const handleChangeRole = (selected) => {
    const roleSelected = selected;
    if (
      selected !== ROLE.Member &&
      !memberDetails?.role?.includes(roleSelected)
    ) {
      modalRef.current.openModal();
      setProfileDataSave({
        ...profileDataSave,
        title: globalVariables.error,
        desc: globalVariables.roleSwitchPermissionError,
        type: "pending",
      });
    } else {
      if (selected === ROLE.Host) {
        dispatch(setHostProfile(memberDetails));
        dispatchSetRole(selected);
      }
      setSelectedRole(selected);
      dispatchSetRole(selected);
    }
  };

  const handleCancel = () => {
    if (selectedTab === SWITCH_ROLE) {
      setSelectedRole(role);
    } else {
      setEditable(false);
    }
  };

  const onCloseModal = () => {
    if (profileDataSave.type === "success") {
      dispatchSetRole(selectedRole);
    }
  };

  const onProfileSuccess = () => {
    modalRef.current.openModal();
    setEditable(false);
    setProfileDataSave({
      ...profileDataSave,
      title: globalVariables.success,
      desc: globalVariables.profileUpdatedSuccessDesc,
      type: "success",
    });
  };

  const onProfileError = (error) => {
    modalRef.current.openModal();
    setProfileDataSave({
      ...profileDataSave,
      title: globalVariables.error,
      desc: error?.message,
      type: "pending",
    });
  };

  const AtiveTab = () => {
    switch (selectedTab) {
      case MEMBER_PROFILE:
        return (
          <MemberProfile
            ref={memberProfileRef}
            isEditable={isEditable}
            onProfileSuccess={onProfileSuccess}
            onProfileError={onProfileError}
            onSetLoading={setLoaderState}
          />
        );
      case HOST_PROFILE:
        return (
          <HostProfile
            ref={hostProfileRef}
            isEditable={isEditable}
            onProfileSuccess={onProfileSuccess}
            onProfileError={onProfileError}
            onSetLoading={setLoaderState}
          />
        );
      case DOG_PROFILE:
        return (
          <DogsProfile
            ref={dogsFormRef}
            isEditable={isEditable}
            data={data}
            loading={DogsLoading}
            onRemoveLoader={() => setLoaderState(false)}
          />
        );
      case SWITCH_ROLE:
        return (
          <SwitchRole
            onChangeRole={handleChangeRole}
            defaultRole={selectedRole}
            rolesData={memberDetails?.role
              // userRole?.includes(ROLE.Judge)
              //   ? [...roles, ROLE.Judge]
              //   : memberDetails?.role
            }
          />
        );
      // case APPLY_FOR_JUDGE:
      //   return <ApplyForJudge />;
      default:
        return <></>;
    }
  };

  const shouldShowSubmitButton = selectedTab !== "Dog(s) Profile";

  return (
    <div className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
        <ScrollToTop />
        <PageInfo title= {globalVariables.myProfile}/>
        <div className="mt-0 md:mt-8 lg:mt-8 px-4" />
        {/* Sticky TabBar with Edit/Save/Cancel buttons */}
        <div className="sticky top-0 z-50 bg-white px-4 py-4 flex justify-center md:justify-between lg:justify-between">
          <TabBar
            tabs={FetchTabs()}
            onChangeTab={onTabChange}
            saveChanges={handelSaveChanges}
          />
          {selectedTab !== SWITCH_ROLE ? (
            (data?.getMyRegisteredDogs.length === 0 &&
              selectedTab === DOG_PROFILE) ||
            selectedTab === APPLY_FOR_JUDGE ? (
              ""
            ) : (
              <SubmitButton
                handleCancel={handleCancel}
                handelSave={handelSaveChanges}
                selectedTab={selectedTab}
                setEditable={setEditable}
                isEditable={isEditable}
              />
            )
          ) : selectedTab !== SWITCH_ROLE ? (
            <SubmitButton
              handleCancel={handleCancel}
              handelSave={handelSaveChanges}
              selectedTab={selectedTab}
              setEditable={setEditable}
              isEditable={isEditable}
            />
          ) : null}
        </div>
        <div className="mt-8" />
        <AtiveTab />
        {/* {option !== "switchRole" ? ( */}
        <div className="md:hidden lg:hidden">
          {isEditable && selectedTab !== SWITCH_ROLE ? (
            <BottomButtons
              outlineLabel={"Cancel Changes"}
              fullLabel={"Save Changes"}
              onTapYes={handelSaveChanges}
              onTapNo={handleCancel}
              position={isMobile ? "fixed" : "sticky"}
              extraClass={isMobile ? "h-[80px]" : "dog-signup-bb-h"}
              btnCustomWidth="w-40 lg:w-44 max-[400px]:w-[140px] max-[280px]:w-[130px]"
            />
          ) : !isEditable &&
            selectedTab !== SWITCH_ROLE &&
            selectedTab !== APPLY_FOR_JUDGE ? (
            // <div
            //   className={`${
            //     data?.getMyRegisteredDogs.length === 0 &&
            //     selectedTab === DOG_PROFILE
            //       ? "hidden"
            //       : "fixed w-full bottom-0 h-20 flex items-center justify-center border border-solid border-gray-300  bg-white"
            //   }`}
            // >
            <div
              className={`${"fixed w-full bottom-0 h-20 flex items-center justify-center border border-solid border-gray-300  bg-white"}`}
            >
              <Button
                onClick={() => setEditable(!isEditable)}
                width={"w-32"}
                label={globalVariables.edit}
                icon={edit}
                prefix={false}
              />
            </div>
          ) : null}
        </div>
        {/* ) : null} */}
      <PopUpMessages
        title={profileDataSave.title}
        desc={profileDataSave.desc}
        type={profileDataSave.type}
        ref={modalRef}
        onCloseModal={onCloseModal}
      />
    </div>
  );
};
